// extracted by mini-css-extract-plugin
export var actionButton = "_c2-t";
export var buttonContainer = "_c2-0";
export var buttonContainer2 = "_c2-1";
export var buttonSection = "_c2-2";
export var details = "_c2-3";
export var dropdownItem = "_c2-5";
export var dropdownItemsContainer = "_c2-4";
export var fileInput = "_c2-r";
export var headerButton = "_c2-6";
export var icon = "_c2-7";
export var input = "_c2-8";
export var macroListItem = "_c2-9";
export var mainContent = "_c2-a";
export var microText = "_c2-b";
export var modal = "_c2-w";
export var optionsButton = "_c2-c";
export var paperclip = "_c2-s";
export var pillContent = "_c2-d";
export var preview = "_c2-e";
export var preview2 = "_c2-f";
export var quillEditor = "_c2-q";
export var selectedMacro = "_c2-g";
export var sidebar = "_c2-h";
export var sidebarHeader = "_c2-j";
export var sidebarList = "_c2-i";
export var sidebarListItem = "_c2-k";
export var sidebarSearch = "_c2-l";
export var snoozeDurationWrapper = "_c2-v";
export var statusPillContainer = "_c2-m";
export var tagsContainer = "_c2-n";
export var unselectedMacro = "_c2-o";
export var variable = "_c2-u";
export var wrapper = "_c2-p";